import { Text } from "@/design-system";
import { cn } from "@/utils";
import { ChevronDown } from "lucide-react";
import type { LegalSection } from "../content/types";
import { LegalTocList } from "./legalTocList";

type LegalTocProps = {
  sections: LegalSection[];
  activeId: string;
  /** Distância do topo da coluna fixa: muda quando a página não tem header. */
  stickyClassName?: string;
};

/**
 * Índice do documento. No desktop é a coluna fixa à esquerda, com a seção em
 * leitura destacada; no celular vira um bloco recolhível acima do texto, para
 * não empurrar o conteúdo uma tela inteira para baixo.
 */
export const LegalToc = ({
  sections,
  activeId,
  stickyClassName = "top-28",
}: LegalTocProps) => (
  <>
    <details className="group border-ds-border bg-ds-surface rounded-ds-lg border lg:hidden">
      <summary className="focus-visible:ring-ds-focus rounded-ds-lg flex min-h-12 cursor-pointer list-none items-center justify-between gap-3 px-4 focus-visible:ring-2 focus-visible:outline-none [&::-webkit-details-marker]:hidden">
        <Text as="span" weight="semibold">
          Neste documento
        </Text>
        <ChevronDown
          aria-hidden="true"
          className="text-ds-ink-600 size-5 transition-transform duration-180 group-open:rotate-180 motion-reduce:transition-none"
        />
      </summary>
      <nav aria-label="Índice do documento" className="px-4 pb-4">
        <LegalTocList sections={sections} activeId={activeId} />
      </nav>
    </details>

    <nav
      aria-label="Índice do documento"
      className={cn("sticky hidden flex-col gap-4 lg:flex", stickyClassName)}
    >
      <Text
        as="p"
        size="caption"
        tone="subtle"
        weight="semibold"
        className="tracking-wide uppercase"
      >
        Neste documento
      </Text>
      <LegalTocList sections={sections} activeId={activeId} />
    </nav>
  </>
);
